var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgIconLanguageGujarati = function SvgIconLanguageGujarati(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 80 80"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 78,
    height: 78,
    x: 1,
    y: 1,
    fill: "#FFF",
    stroke: "#1B75BB",
    strokeWidth: 2,
    rx: 13
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B75BB",
    d: "M47.059 44.882H36.387v2.27c0 .14-.042.384-.126.735-.085.35-.267.714-.547 1.092-.28.378-.679.714-1.197 1.008-.518.295-1.212.442-2.08.442-1.177 0-2.367-.267-3.571-.799a13.207 13.207 0 01-3.278-2.059c-.98-.84-1.778-1.8-2.395-2.878-.616-1.078-.924-2.164-.924-3.256 0-.98.35-1.786 1.05-2.416.7-.63 1.751-.945 3.152-.945h1.848v-13.11c0-.56-.049-.952-.147-1.176-.098-.224-.217-.336-.357-.336-.084 0-.28.14-.588.42-.308.28-.84.826-1.597 1.639l-4.538-3.824c.365-.644.806-1.267 1.324-1.87a10.22 10.22 0 011.765-1.617 9.034 9.034 0 012.185-1.156 7.417 7.417 0 012.584-.441c1.092 0 2.1.196 3.025.588a6.998 6.998 0 012.353 1.597 7.32 7.32 0 011.512 2.374 7.79 7.79 0 01.547 2.92v13.992h10.672v-21.05h8.067v38.99c0 .14.056.309.168.505.112.196.294.294.546.294.308 0 .582-.126.82-.378s.483-.616.735-1.092l4.496 3.95c-.224.587-.588 1.183-1.093 1.785a9.535 9.535 0 01-1.827 1.66 9.74 9.74 0 01-2.374 1.218 8.106 8.106 0 01-2.731.462c-1.12 0-2.108-.21-2.963-.63a6.146 6.146 0 01-2.121-1.68 7.625 7.625 0 01-1.282-2.375 8.516 8.516 0 01-.441-2.71V44.882z"
  }))));
};
export default SvgIconLanguageGujarati;